import {
  GET_INTEREST_SENT_USERS_SUCCESS,
  GET_CARRIER_DETAILS,
  ADD_ADMIN_UPLOADED_DOC_FOR_CARRIER,
  GET_CARRIER_DOCUMENTS_SUCCESS,
  GET_CARRIER_COMMENTS_SUCCESS,
  UPDATE_SHA_STATUS_LOCALLY,
  UPDATE_COMPLIANCE_LOCALLY,
  CLEAR_ADMIN_UPLOADED_DOCS,
  REMOVE_ADMIN_UPLOADED_DOC_FOR_CARRIER_BEFORE_SUBMIT,
  CLEAR_COMMENTS_AND_DOCS_OF_CURRENT_USER,
  FETCH_CARRIER_COMMUNICATION_HISTORY_SUCCESS,
  UPDATE_COMM_HISTORY_LOCALLY,
  SET_COMMUNICATION_HISTORY_LOADING,
  CLEAR_ALL_CARRIER_DATA_LOCALLY,
  SET_CARRIER_DETAILS_LOADING,
  GET_CARRIER_DETAILS_EXTERNAL_SOURCES_SUCCESS,
  GET_USER_PROFILE_INFO_SUCCESS,
  GET_CARRIER_QUESTIONNAIRE_SUCCESS,
  GET_CARRIER_LANE_PREFERENCES_SUCCESS,
  GET_CARRIER_COMMENTS_WITH_TYPE_SUCCESS
} from '../actions/Lanes';

const INIT_STATE = {
  isCarrierDetailsLoading: true,
  interestSentUsersData: {},
  userCarrierDetails: {},
  adminUploadedDocForCarrier: [],
  carrierDocuments: [],
  carrierComments: [],
  carrierCommunicationHistory: {
    isLoading: false,
    data: []
  },
  carrierInfoFromExteranlSources: {
    user: {},
    saferweb: {},
    mcp: {}
  },
  userDetailsFromAppService: {},
  lanePreferences: []
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {

    case GET_INTEREST_SENT_USERS_SUCCESS: {
      return {
        ...state,
        interestSentUsersData: action?.payload ?? {}
      };
    }
    case GET_CARRIER_DETAILS: {
      return {
        ...state,
        userCarrierDetails: action?.payload ?? {}
      };
    }
    case GET_CARRIER_DETAILS_EXTERNAL_SOURCES_SUCCESS: {
      if (!action?.payload) return state;
      return {
        ...state,
        carrierInfoFromExteranlSources: action?.payload
      };
    }
    case GET_USER_PROFILE_INFO_SUCCESS: {
      return {
        ...state,
        userDetailsFromAppService: action?.payload ?? {}
      };
    }
    case GET_CARRIER_LANE_PREFERENCES_SUCCESS: {
      return {
        ...state,
        lanePreferences: action?.payload?.sort((a, b) => a.created_at - b.created_at) ?? []
      };
    }
    case ADD_ADMIN_UPLOADED_DOC_FOR_CARRIER: {
      return {
        ...state,
        adminUploadedDocForCarrier: [...state.adminUploadedDocForCarrier, action.payload]
      };
    }
    case REMOVE_ADMIN_UPLOADED_DOC_FOR_CARRIER_BEFORE_SUBMIT: {
      let newDocs = state.adminUploadedDocForCarrier.filter(url => url != action.payload)
      return {
        ...state,
        adminUploadedDocForCarrier: [...newDocs]
      };
    }
    case GET_CARRIER_DOCUMENTS_SUCCESS: {
      return {
        ...state,
        carrierDocuments: action.payload ?? []
      };
    }

    case GET_CARRIER_COMMENTS_SUCCESS: {
      return {
        ...state,
        carrierComments: action.payload ?? []
      };
    }
    case GET_CARRIER_COMMENTS_WITH_TYPE_SUCCESS: {
      const otherCommants = state.carrierComments.filter(comment => comment.type !== action.commentType)
      return {
        ...state,
        carrierComments: [...otherCommants, ...action.payload] ?? []
      };
    }
    case UPDATE_SHA_STATUS_LOCALLY: {
      if (state?.userCarrierDetails?.carrier?.sha_status) {
        state.userCarrierDetails.carrier.sha_status = action.payload
        return {
          ...state
        };
      } else {
        return {
          ...state
        }
      }

    }
    case CLEAR_ADMIN_UPLOADED_DOCS: {
      return {
        ...state,
        adminUploadedDocForCarrier: []
      }
    }

    case UPDATE_COMPLIANCE_LOCALLY: {
      if (state?.userCarrierDetails?.carrier) {
        state.userCarrierDetails.carrier.compliance_status = action.payload
      }
      return {
        ...state
      }
    }

    case CLEAR_COMMENTS_AND_DOCS_OF_CURRENT_USER: {
      return {
        ...state,
        carrierDocuments: [],
        carrierComments: []
      }
    }

    case FETCH_CARRIER_COMMUNICATION_HISTORY_SUCCESS: {
      return {
        ...state,
        carrierCommunicationHistory: {
          isLoading: false,
          data: action.payload ?? {}
        }
      }
    }

    case UPDATE_COMM_HISTORY_LOCALLY: {
      state.carrierCommunicationHistory.data.forEach((communication, i) => {
        if (communication?.id !== action?.payload?.communication_id) return;
        state.carrierCommunicationHistory.data[i] = { ...action?.payload?.data, id: action?.payload?.communication_id }
      })
      return {
        ...state,
        carrierCommunicationHistory: {
          ...state.carrierCommunicationHistory
        }
      }
    }

    case SET_COMMUNICATION_HISTORY_LOADING: {
      return {
        ...state,
        carrierCommunicationHistory: {
          ...state.carrierCommunicationHistory,
          isLoading: action.payload,
        }
      }
    }

    case SET_CARRIER_DETAILS_LOADING: {
      return {
        ...state,
        isCarrierDetailsLoading: action.payload
      }
    }

    case CLEAR_ALL_CARRIER_DATA_LOCALLY: {
      return {
        ...INIT_STATE,
        interestSentUsersData: state.interestSentUsersData
      }
    }

    default:
      return state;
  }
};
